import { EditPage, EditPageTextField, EditPageCheckbox, EditPageSelect, EditPagePanel } from './../../../common/EditPage';
import { create, getOne } from './../../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

const PaymentTermCreate = () => {
    const navigate = useNavigate();
    const [data, setData] = useState({
        name: '',
        description: '',
        days_cycle: 7,
        days_grace: 7,
        days_notify: '7,14,21'
    });
    
    const handleSave = () => {
        create('/admin/settings/payment_terms', {data: data}).then(response => {
            toast.success("Payment term created successfully", {});
            navigate('/settings/payment_terms');
        }).catch(error => {
            toast.error("Error creating payment term: " + error.message, {});
        });
    }
    const handleCancel = () => {
        navigate('/settings/payment_terms');
    }
    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }
    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title="Create Payment Term" >
                <EditPagePanel>
                    <EditPageTextField label="Name" id="name" onChange={ onChange } value={ data.name } />
                    <EditPageTextField label="Description" id="description" onChange={ onChange } value={ data.description } />
                    <EditPageTextField label="Cycle Days" id="days_cycle" onChange={ onChange } value={ data.days_cycle } />
                    <EditPageTextField label="Grace Days" id="days_grace" onChange={ onChange } value={ data.days_grace } />
                    <EditPageTextField label="Notify Days (comma separated)" id="days_notify" onChange={ onChange } value={ data.days_notify } />
                </EditPagePanel>
            </EditPage>
        </div>
    )
}

export default PaymentTermCreate;